<template>
  <a
    class="close iconfont icon-close"
    :class="pointClass"
    href="javascript:;"
    v-bind="$attrs"
    @click="handleClick"
  ></a>
</template>

<script>
export default {
  name: 'Close',
  props: {
    pointClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    }
  }
};
</script>

<style lang="scss" scoped>
.close {
  position: relative;
  font-size: 22px;
  font-weight: bold;
  color: var(--back-color);
}
</style>
